// extracted by mini-css-extract-plugin
export default {"footerBg":"E-z","footerTopLinks":"F-z","footerFeedback":"G-z","footerSocial":"H-z","footerLegalLinks":"I-z","footerIconCards":"J-z","footerBotCopy":"K-z"};